import { Component, ComponentFactoryResolver, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ProductoModel, Data as DataProducto } from 'src/app/shared/models/producto/producto.model';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { CarritoService } from 'src/app/shared/services/carrito/carrito.service';
import { ToastrService } from 'ngx-toastr';
import { ProductoService } from 'src/app/shared/services/producto/producto.service';
import { EquivalenteModel, Data as DataEquivalencia } from 'src/app/shared/models/producto/equivalente.model';
import { AplicacionModel, Data as DataAplicaciion } from 'src/app/shared/models/producto/aplicacion.model';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ComingSoonModule } from 'src/app/pages/coming-soon/coming-soon.module';
import { ImagenModel, Data as DataImagen } from 'src/app/shared/models/producto/imagen.model';
import { ParametroModel } from 'src/app/shared/models/producto/parametro.model';
import { NgxMaskModule } from 'ngx-mask';


@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.scss']
})
export class ProductViewComponent implements OnInit {
  
  @Input() muestraFinal;
  @Input() muestraLista;
  @Input() muestraNeto;
  @Input() mostrarPrecio;
  @Input() mostrarPrecioFinalRjt:boolean=false;
  @Input() mostrarPrecioRjtSinIva:boolean=false;

  @ViewChild("quickView", { static: false }) QuickView: TemplateRef<any>;
  public closeResult: string;
  public modalOpen: boolean = false;
  public producto: DataProducto;
  public counter: number = 1;

  public maskCant = "0000";

  public equivalentes: DataEquivalencia[] = [];
  public relacionadas: DataEquivalencia[] = [];
  public aplicaciones: DataAplicaciion[] = [];

  public hasEquivalente: boolean = false;
  public hasRelacionada: boolean = false;
  public hasAplicacion: boolean = false;
  public controlStock: boolean = this.configService.config.productos.control_stock;
  public tituloSinStock: string = this.configService.config.productos.titulo_sin_stock;
  public tituloStockMinimo = this.configService.config.productos.titulo_stock_minimo;
  public tituloStockDisponible = this.configService.config.productos.titulo_stock_disponible;
  public mostrarEtiquetaMinimo = this.configService.config.productos.mostrar_etiqueta_minimo;

  public config = this.configService.config;
  public invitado: boolean = false;


    // SC CATWEB-337 CATWEB-351 10/09/2021 arreglo de imagenes del producto.
    public images: DataImagen[] = [];
    // SC CATWEB-350 CATWEB-351 14/09/2021 arreglo que acumula una pila de productos utilizada para volver a los productos anterior.
    public backProducts = [];

  // SC CATWEB-350 CATWEB-351 14/09/2021 variable de datos para realizar la busqueda de un producto.
  private datos: ParametroModel = {
    PageNumber: 1,
    PageSize: 1,
    ConStock: 'S',
    IncluyeSubFamilia: 'S',
    SoloConAplic:'N'
  };

  // MC - Propiedades usadas en el carousel
  activeIndex: number = 0;
  displayBasic2: boolean = false;


  constructor(private modalService: NgbModal,
    private authService: AuthService,
    private carritoService: CarritoService,
    private productoService: ProductoService,
    private configService: ConfigService,
    public toastr: ToastrService,
    ) { }

  ngOnInit(): void {
    this.invitado = this.authService.usuario.invitado;
  }

  openModal(producto: DataProducto) {
    this.backProducts = [];
    this.cargarDatosProductos(producto);
    this.modalOpen = true;
    this.modalService.open(this.QuickView, { 
    size: 'lg',
    ariaLabelledBy: 'modal-basic-title',
    centered: true,
    scrollable: false,
    windowClass: 'Quickview'
    }).result.then((result) => {
      `Result ${result}`
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public increment() {
    
    console.log(typeof this.counter);
    if(this.counter <= this.producto.Articulo.Stock.CantidadFisica){
      this.counter += 1;
    }
  }

  public decrement() {
    
      if (this.counter > 1) {
        this.counter -= 1;
      }

  }

  add(producto:DataProducto ){
    if(this.counter > 0){
      if(this.carritoService.validarStock(this.counter, producto.Articulo.Stock.CantidadFisica)){
        let item =  {
          "id_cliente": this.authService.usuario.id_cliente,
          "id_producto": producto.Articulo.IdArticulo,
          "nombre":producto.Articulo.Nombre,
          "codigo":producto.Articulo.Codigo,
          "imagen":producto.Articulo.ImagenesArticulo[0].Imagen,
          "precio": producto.Articulo.PreciosArticulo[0].PrecioFinal,
          "precio_neto": producto.Articulo.PreciosArticulo[0].PrecioNeto,
          "precio_lista": producto.Articulo.PreciosArticulo[0].PrecioLista,
          "cantidad": this.counter,
          "stock":producto.Articulo.Stock.CantidadFisica
      };
        const result= this.carritoService.changeCart(item, true);
      if(result){
        this.toastr.success(`${producto.Articulo.Nombre} `+ CarritoService.MSG_ADD_CART, '', {
          timeOut: 2000,
        });
      }else{
        this.toastr.error(CarritoService.MSG_ERROR_CART);
      }
      }else{
        this.toastr.error(CarritoService.MSG_ERROR_STOCK);
      }
    }else{
      this.toastr.error(CarritoService.MSG_ERROR_CANT_MIN);
    }
    

  }

  // SC CATWEB-316 / CATWEB-317 Funcion que obtiene sugun el tipo_relacion (E o R), los productos equivalentes(E), o Relacionados (R) de un producto. 
  cargarEquivalentes(id_articulo:number, tipo_relacion: string, codigo: string){
   const susc = this.productoService.getEquivalentes(tipo_relacion, id_articulo, codigo).subscribe((resp) => {
      if (resp.Succeeded && resp.Data) {
        switch (tipo_relacion) {
          case 'E':
            if(resp.Data.length > 0){
              this.equivalentes = resp.Data;
            }else{
              this.equivalentes = [];
              this.hasEquivalente = false;
            }
            
            break;
        
          case 'R':
            if(resp.Data.length > 0){
            this.relacionadas = resp.Data;
            }else{
              this.relacionadas = [];
              this.hasRelacionada = false;
            }
          default:
            break;
        }
      }

    });
    susc.unsubscribe;
  }

  // SC CATWEB-318 Funcion que obtiene arreglo de aplicaciones de un producto.
  cargarAplicacion(id_articulo:number){
    
    const susc = this.productoService.getAplicaciones(id_articulo).subscribe((resp) => {
      if (resp.Succeeded && resp.Data) {
        if(resp.Data.length > 0){
          this.aplicaciones = resp.Data;
        }else{
          this.aplicaciones = [];
          this.hasAplicacion = false;
        }
        
      }
  
    });
    susc.unsubscribe;
  }

  // SC CATWEB-318 Se carga segun tab los arreglos, actualmente no se usa dado que los numeros de tab se incrementan (ver si se puede fijar los numeros de tab).
  selectTab(event){
    // console.log(event);
    switch (event.nextId) {
      case "ngb-tab-0":
        this.cargarAplicacion(this.producto.Articulo.IdArticulo);
        break;
    
      case "ngb-tab-1":
        this.cargarEquivalentes(this.producto.Articulo.IdArticulo, 'E', this.producto.Articulo.Codigo);
        break;
      case "ngb-tab-2":
        this.cargarEquivalentes(this.producto.Articulo.IdArticulo, 'R', this.producto.Articulo.Codigo);
        break;
      default:
        break;
    }
  }

  // SC CATWEB-318 Funcion inicializa arreglos de aplicacion, equivalentes y relacionadas.
  inicializar(){

    this.cargarImagenesProducto(this.producto.Articulo.Codigo);
    
    if(this.hasAplicacion){
      this.cargarAplicacion(this.producto.Articulo.IdArticulo);
    }
    if(this.hasEquivalente){
      this.cargarEquivalentes(this.producto.Articulo.IdArticulo, 'E', this.producto.Articulo.Codigo);
    }
    if(this.hasRelacionada){
      this.cargarEquivalentes(this.producto.Articulo.IdArticulo, 'R', this.producto.Articulo.Codigo);
    }

  }

  // SC CATWEB-350 CATWEB-351 14/09/2021 Funcion carga el modal con el producto equivalente / relacionado.
  openModal2(codigo : number){
    
    this.datos.Codigo = codigo.toString();
    const suc = this.productoService.getProductos(this.datos).subscribe(resp => {
      if(resp.Data.length > 0){
        this.backProducts.push(this.producto.Articulo.Codigo);
        this.cargarDatosProductos(resp[0]);
      }else{
        this.toastr.error('Producto no publicado');
      }
    }
    );
    suc.unsubscribe;
  }

  // SC CATWEB-350 CATWEB-351 14/09/2021 Funcion recarga el modal con el producto anterior.
  back(){
    this.datos.Codigo = this.backProducts.pop().toString();
    const suc = this.productoService.getProductos(this.datos).subscribe(resp => {
      if(resp.Data.length > 0){
        this.cargarDatosProductos(resp[0]);
      }else{
        this.toastr.error('Producto no publicado');
      }
  }
  );
  suc.unsubscribe;
}
// SC CATWEB-350 CATWEB-351 14/09/2021 Funcion inicializa y carga el producto en el modal
  cargarDatosProductos(producto:DataProducto){


    // SC CATWEB-318 / CATWEB-316 / CATWEB-317se inicializan los arreglos a vacios.
    this.aplicaciones = [];
    this.relacionadas = [];
    this.equivalentes = [];
    this.images = []
    // SC CATWEB-324 se setea el producto que se recibe como parametro al abrir al modal y se inicializa el contador de cantidad de productos para sumar al carrito.
    this.producto = producto;
    this.counter = 1;
    
    // SC CATWEB-318 / CATWEB-316 / CATWEB-317 setean las variables que indican si tienen o no aplicaciones, equivalentes o relacionadas.
    if (producto.Articulo.ConfiguracionArticulo != undefined) {
      this.hasAplicacion = producto.Articulo.ConfiguracionArticulo.TieneAplicacion == 'S'? true: false;
      this.hasEquivalente = producto.Articulo.ConfiguracionArticulo.TieneEquivalencias == 'S'? true: false;
      this.hasRelacionada = producto.Articulo.ConfiguracionArticulo.TienePartesRel == 'S'? true: false;
    }
    
    this.inicializar();

  }

  // MV CATWEB 364 Funcion que obtiene las imagenes del producto y las guarda en el arreglo de imagenes
  cargarImagenesProducto(codigo: string){
    
    const susc = this.productoService.getImagenesArticulo(codigo).subscribe(imagenes => {
      if(imagenes.length > 0){
        
        let id = 1;
        imagenes.forEach(element => {
          let img:DataImagen = {
            Id:id,
            Orden:id,
            TipoMedia:"I",
            Nombre:element
          };
          this.images.push(img);
          id++;
        });
        // this.images = imagenes.Data;
        // let id = 1;
        // this.images.forEach(img => {
        // img.Id = id;
        //   id++;
        // });
      } else{
        this.images = [{Id: 1,Nombre: "assets/images/productos/default.png", TipoMedia: "I", Orden: 1}];
      }
      console.log(imagenes)
    });
    susc.unsubscribe;
  }


  // Opciones de configuracion carousel de imagenes
  owlcarousel14Options = {
    items: 1,
    margin: 10,
    autoHeight: false,
    nav: false,
    dots: true,
    autoplay: true,
    slideSpeed: 300,
    loop: true,
  }

  // MC - Función para activar el carousel
  imageClick (index) {
    this.activeIndex = index;
    this.displayBasic2 = true;
  }

}

